import { render } from "./salaryPerson.vue?vue&type=template&id=1aca2f8a&scoped=true"
import script from "./salaryPerson.vue?vue&type=script&lang=js"
export * from "./salaryPerson.vue?vue&type=script&lang=js"

import "./salaryPerson.vue?vue&type=style&index=0&id=1aca2f8a&lang=scss&scoped=true"
import "./salaryPerson.vue?vue&type=style&index=1&id=1aca2f8a&lang=css"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aca2f8a"]])

export default __exports__